module.exports = __webpack_public_path__ + "static/media/howtobuy.2d922a46.png";